import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  verificationClicks: {},
}

const aiVerificationSlice = createSlice({
  name: 'aiVerification',
  initialState,
  reducers: {
    setVerificationClick: (state, action) => {
      const { nodeId, status } = action.payload
      state.verificationClicks[nodeId] = status
    },
    resetVerificationClicks: (state) => {
      state.verificationClicks = {}
    },
  },
})

export const { setVerificationClick, resetVerificationClicks } = aiVerificationSlice.actions
export default aiVerificationSlice.reducer
